/** @fileoverview Renders the ordered activity timeline for a chat message. */

import { MessageResponse } from '../ai-elements/message';
import ChatActivity, { ChatSkillActivity } from './ChatActivity';
import type { ChatMessageTimelineProps } from './types';

export default function ChatMessageTimeline({ items }: ChatMessageTimelineProps) {
  return items.map((item) => {
    if (item.kind === 'reasoning') {
      return (
        <MessageResponse
          className="prose prose-sm min-w-0 max-w-full wrap-anywhere text-app-text-muted dark:prose-invert [&_pre]:max-w-full [&_pre]:overflow-x-auto [&_p]:my-1 [&_ul]:my-1 [&_ol]:my-1"
          key={item.key}
        >
          {item.text}
        </MessageResponse>
      );
    }
    if (item.kind === 'tool-group') {
      return <ChatActivity entries={item.entries} key={item.key} />;
    }
    return <ChatSkillActivity entry={item.entry} key={item.key} />;
  });
}
